// <!-- AI-authored: Darby's Claude -->
/**
 * What the browser reporter and the Health route both call a failed
 * telemetry request: no response at all (status 0: blocked, network error,
 * abort) or an HTTP error. One definition for both ends so the route never
 * refuses what the reporter sends, and never records a success as a failure.
 */
export function isTelemetryRequestFailure(statusCode: number): boolean {
  return statusCode === 0 || statusCode >= 400;
}
